<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <!--地址组件-->
        <template v-if="configObj.showAddress">
          <c-panel-container v-if="haveSetAddress">
            <c-panel :title="showUserBaseInfo" :desc="showUserAddress"
                     @click.native="editAddress">
              <div class="right-point"></div>
            </c-panel>
          </c-panel-container>
          <c-cell-container v-else class="mg-0">
            <c-cell class="cell-item" :icon="require('../../../assets/images/icon/plus-icon.svg')" title="设置收货地址"
                    @click.native="editAddress"></c-cell>
          </c-cell-container>
        </template>
        <br>
        <c-panel-container>
          <c-panel :title="goodsName" :desc="`x ${goodsCount}`" :img="goodsIcon">
            <div class="price">{{ goodsPrice | currency0 }}</div>
          </c-panel>
          <c-panel title="" desc="">
            共{{goodsCount}}件商品 小计:
            <div class="price">{{ goodsTotalPrice | currency0 }}</div>
          </c-panel>
        </c-panel-container>
        <c-cell-container>
          <template v-if="configObj.showAddress">
            <c-cell class="cell-item" title="运费" :desc="goodsMailPriceText" :point="false"></c-cell>
          </template>
          <c-cell v-if="!notUseTicket && ticketCount > 0"
                  class="cell-item" title="礼金券"
                  :desc="couponSelected ? `${couponSelected.price}元`:`${ticketCount}张可用`"
                  @click.native="selectGoodsTicket"></c-cell>
          <div class="weui-cell weui-cell_switch cell-item" v-if="!notUseIntegral && accountIntegral > 0">
            <div class="weui-cell__bd">可用 {{ accountIntegral }}积分 抵 {{ intergralToCurrency
              }} 元 <span v-show="useIntegral">(剩余{{ remainingIntegral }})</span></div>
            <div class="weui-cell__ft" style="font-size: 0">
              <input class="weui-switch" type="checkbox" v-model="useIntegral">
            </div>
          </div>
        </c-cell-container>
        <!--remark-->
        <template v-if="configObj.showRemark">
          <c-form>
            <div class="weui-cell cell-item">
              <div class="weui-cell__hd">
                <label class="weui-label">买家留言</label></div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="text" placeholder="选填，可输入对本次交易的说明" v-model="remark">
              </div>
            </div>
          </c-form>
        </template>
      </c-content>
      <c-footer>
        <div class="pay">
          <div class="total-price">
            <span class="price-text">实付：</span>
            <span class="price">{{ goodsFinalPrice | currency0 }}</span>
          </div>
          <div class="pay-btn" @click="payProcess">
            立即支付
          </div>
        </div>
      </c-footer>
    </c-page>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import Vue from 'vue'
  import * as StoreTypes from '../../../store/mutation-types'
  import debounce from 'lodash.debounce'
  import UserAddress from '../../../model/user-address'
  import AboutUser from '../../../model/about-user'
  import Pay from '../../../model/pay'
  import event from '../../../tools/event'
  import Goods from '../../../model/goods'
  import api from '@/tools/api-tools'
  import device from '@/tools/device'
  import {mainWeb, mainWebResource, mainWebPostData} from '@/config/net'

  export default {
    data () {
      return {
        reducePrice20171111: 0, // 双11实体卡减掉金额
        goodsId: 0,
        goodsName: '',
        goodsCount: 1,
        goodsIcon: '',
        goodsPrice: null,
        accountIntegral: 0,
        ticketPrice: 0,
        useIntegral: false,
        remainingIntegral: 0,
        commuteIntegral: 0,
        couponSelected: null,
        userAddressModel: new UserAddress(),
        aboutUser: new AboutUser(),
        remark: '',
        pay: new Pay(),
        notUseIntegral: false, // 不能用积分
        notUseTicket: false // 不能用礼金券
      }
    },
    components: {},
    created () {
      this.$store.dispatch(StoreTypes.ORDER_TICKET)
      this.$bus.$on('couponSelected', (obj) => {
        this.couponSelected = obj
      })
      event.createOrderSuccessHook.on(() => {
        // 清理已经选择的优惠券
        this.couponSelected = null
        this.$store.dispatch(StoreTypes.ORDER_TICKET)
      })
      Promise.all([
        this.userAddressModel.loadData(),
        this.aboutUser.integral()
      ]).then(values => {
        this.$store.commit('setUserAddressObj', values[0])
        this.accountIntegral = values[1].accountIntegral
      }).catch(e => {
      })
      let goodsInfo = this.$store.getters.getOrderGoodsInfo
      this.goodsName = goodsInfo.name
      this.goodsCount = goodsInfo.count
      this.goodsPrice = goodsInfo.price
      this.goodsId = goodsInfo.goodsId
      this.goodsIcon = goodsInfo.icon
      this.notUseIntegral = goodsInfo.isIntegralUnAvaliable
      this.notUseTicket = goodsInfo.isCouponUnAvaliable
      this.remark = goodsInfo.remark
      this.goodsType = goodsInfo.goodsType
    },
    mounted () {
      this._canReduceThePrice()
    },
    beforeDestroy () {
    },
    methods: {
      _canReduceThePrice () {
        if (device.ios && [Goods.saas.physicalAdvancedCard.id, Goods.saas.physicalProfessional.id].includes(Number(this.goodsId))) {
          this._getReducePrice()
        }
        if ([Goods.saas.a8Pos.id].includes(Number(this.goodsId))) {
          this._getReducePrice()
        }
      },
      _getReducePrice () {
        api.post(`${mainWeb}${mainWebResource}`, mainWebPostData('carddiscount', {
          goodsId: this.goodsId
        })).then(res => {
          let data = res.data || {}
          let reducePrice = Number(data.Model)
          this.reducePrice20171111 = Number.isNaN(reducePrice) ? 0 : reducePrice
        })
      },
      editAddress: debounce(function () {
        this.$router.push({path: `${this.$route.path}/editOrderAddress`})
      }, 220),
      selectGoodsTicket: debounce(function () {
        this.$router.push({path: `${this.$route.path}/selectGoodsTicket`})
      }, 220),
      payProcess: debounce(function () {
        // 只有设置了显示收货地址，才会验证是否设置收货地址
        if (this.configObj.showAddress && !this.haveSetAddress) {
          this.$wejs.topTips('请设置收货地址', 950)
          return
        }
        let commuteIntegral = this.commuteIntegral
        if (!this.useIntegral) commuteIntegral = 0
        let couponCode = this.couponSelected ? this.couponSelected.couponCode : ''
        if (this.goodsType === 1) {
          let payObj = this.pay.payObj({
            goodsId: this.goodsId,
            goodsType: this.goodsType,
            quantity: this.goodsCount,
            couponCode,
            commuteIntegral,
            remark: this.remark
          })
          return this.pay.createOrder(payObj)
        }
        this.pay.hardwarePay(this.goodsId, this.goodsCount, couponCode, commuteIntegral, this.remark)
      }, 220)
    },
    computed: {
      configObj () {
        return this.$store.getters.getOrderConfirmConfig
      },
      ticketCount () {
        return this.$store.getters[StoreTypes.ORDER_TICKET].length
      },
      haveSetAddress () {
        return this.userAddressObj.userName && this.userAddressObj.userName.length > 0
      },
      userAddressObj () {
        return this.$store.getters.getUserAddressObj
      },
      showUserBaseInfo () {
        return `${this.userAddressObj.userName} ${this.userAddressObj.userPhone}`
      },
      showUserAddress () {
        return `${this.userAddressObj.userAddress.join(' ')} ${this.userAddressObj.userAddressDetail}`
      },
      // TODO 计算邮费
      goodsMailPrice () {
        let price = 0
        let mailPrice = 0
        if (this.userAddressObj.userAddress && this.userAddressObj.userAddress.length > 0) {
          for (let item of ['西藏', '新疆']) {
            price = this.userAddressObj.userAddress[0] === item ? mailPrice : 0
          }
        }
        return price
      },
      goodsTotalPrice () {
        return this.goodsCount * this.goodsPrice
      },
      goodsFinalPrice () {
        let price = this.goodsCount * this.goodsPrice + this.goodsMailPrice
        price -= this.couponSelected ? parseInt(this.couponSelected.price) : 0
        // 金额的8%可以用券抵
        if (this.useIntegral) {
          let nowIntergral = this.intergralToCurrency
          let discountPrice = price * 0.08
          let discountFinalPrice = nowIntergral >= discountPrice ? discountPrice : nowIntergral
          price -= discountFinalPrice
          this.commuteIntegral = Math.floor(discountFinalPrice).toFixed(0) * 100
          this.remainingIntegral = this.accountIntegral - this.commuteIntegral
        }
        price -= this.reducePrice20171111 // 2017双11实体卡满减控制
        price = price <= 0 ? 0 : price // price一定不小于零
        return Math.ceil(price)
      },
      goodsMailPriceText () {
        return this.goodsMailPrice === 0 ? '免邮' : Vue.filter('currency0')(this.goodsMailPrice)
      },
      intergralToCurrency () {
        return Math.floor(this.accountIntegral / 100)
      }
    },
    watch: {
      useIntegral (val) {
        if (val) {
          if (this.couponSelected) {
            this.$wejs.alert('积分与礼金券不能同时使用哦~', {title: '温馨提示'})
          }
          this.couponSelected = null
        }
      },
      couponSelected (val) {
        if (val) {
          if (this.useIntegral) {
            this.useIntegral = false
            this.$wejs.alert('积分与礼金券不能同时使用哦~', {title: '温馨提示'})
          }
        }
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?50dabd54